import { render, staticRenderFns } from "./channel-manage.vue?vue&type=template&id=0c598cab&scoped=true&"
import script from "./channel-manage.vue?vue&type=script&lang=js&"
export * from "./channel-manage.vue?vue&type=script&lang=js&"
import style0 from "./channel-manage.vue?vue&type=style&index=0&id=0c598cab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c598cab",
  null
  
)

export default component.exports